import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    boosterRewards: 'Booster rewards',
    apy: 'APY {value}%',
    stakeFor: 'Stake for {stakedToken}',
    claim: 'Claim',
  },
};
